document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartItems', (context) => {
    return {
      context: context,
      itemsRoot: null,
      locked: null,
      items_section: '',
      sections: '',
      init() {
        if (context === 'drawer') {
          this.items_section = 'drawer-cart-items';
          this.sections =
            'drawer-cart-items,drawer-cart-footer,cart-item-count,cart-live-region';
        } else {
          this.items_section = 'cart-items';
          this.sections =
            'cart-items,cart-footer,cart-item-count,cart-live-region';
        }

        this.itemsRoot = this.$root;

        window.addEventListener('switch:cart:afteradditem', (e) => {
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections[this.items_section]
            ).outerHTML
          );
          this.$nextTick(() => {
            document.body.dispatchEvent(new CustomEvent('switch:load:images', { bubbles: true }));
          });
        });

        window.addEventListener('switch:modalcart:cartqtychange', (e) => {
          if (!this.itemsRoot.contains(e.detail.originalTarget)) return;

          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections[this.items_section]
            ).outerHTML
          );

          this.$nextTick(() => {
            document.body.dispatchEvent(new CustomEvent('switch:load:images', { bubbles: true }));
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
          });

          const liveRegionText = parseDOMFromString(
            e.detail.response.sections['cart-live-region']
          ).firstElementChild.textContent;

          const cartStatus = document.getElementById('cart-live-region-text');

          cartStatus.textContent = liveRegionText;

          cartStatus.setAttribute('aria-hidden', false);

          setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
          }, 1000);

          if (e.detail.originalTarget) {
            this.$nextTick(() => {
              if (!this.itemsRoot.contains(e.detail.originalTarget)) {
                let focusRoot;

                if (this.itemsRoot.closest('[role="dialog"]')) {
                  focusRoot =
                    this.itemsRoot.closest('[role="dialog"]').parentNode;
                } else {
                  focusRoot = this.itemsRoot;
                }

                this.$focus.within(focusRoot).first();
              }
            });
          }
        });
      },
      itemQuantityChange(key, value) {
        if (this.locked) return;

        const lineItemEl = key
          ? this.itemsRoot.querySelector('li[data-cart-item-key="' + key + '"]')
          : this.$el.closest('li[data-cart-item-key]');

        const id = key ? key : (lineItemEl ? lineItemEl.getAttribute('data-cart-item-key') : null);
        if (!id) return;

        const quantity = parseInt(!isNaN(value) ? value : this.$el.value, 10);

        const config = fetchConfigDefaults();

        let sections = this.sections;

        config.headers.Accept = 'application/javascript';

        config.body = JSON.stringify({
          id,
          quantity,
          sections,
          sections_url: window.location.pathname,
        });

        const lastValue = value !== undefined
          ? (lineItemEl ? parseInt(lineItemEl.querySelector('input[type="number"]').dataset.lastValue, 10) : quantity + 1)
          : parseInt(this.$el.dataset.lastValue, 10);

        if (quantity !== lastValue) {
          if (lineItemEl) lineItemEl.classList.add('opacity-50', 'cursor-progress');

          this.locked = lineItemEl || true;

          fetch(theme.routes.cart_change_url, config)
            .then((res) => res.json())
            .then((data) => {
              if (data.status === 422) {
                if (lineItemEl) {
                  const errorEl = lineItemEl.querySelector(
                    '[data-cart-quantity-error]'
                  );
                  if (errorEl) {
                    errorEl.textContent = data.message;
                    errorEl.classList.remove('hidden');
                  }
                  lineItemEl.classList.remove('opacity-50', 'cursor-progress');
                }
                if (!key && this.$el && this.$el.tagName === 'INPUT') {
                  this.$el.value = lastValue;
                  this.$el.dispatchEvent(new Event('input'));
                }
              } else {
                document.body.dispatchEvent(
                  new CustomEvent('switch:modalcart:cartqtychange', {
                    bubbles: true,
                    detail: { response: data, originalTarget: lineItemEl || this.itemsRoot },
                  })
                );
              }
            })
            .catch(() => {
              const cartErrors = document.getElementById('cart-errors');
              if (cartErrors) cartErrors.textContent = theme.strings.cartError;
            })
            .finally(() => {
              this.locked = null;
            });
        }
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      _adjustQty(el, operation) {
        const liEl = el.closest('li[data-cart-item-key]') || el.closest('li[key]');
        if (!liEl) return;
        const inputEl = liEl.querySelector('input[type="number"]');
        if (!inputEl) return;

        const key = liEl.getAttribute('data-cart-item-key');
        const lastValue = parseInt(inputEl.dataset.lastValue, 10);

        let newValue;

        if (operation === 'increment') {
          newValue = lastValue + 1;
        }

        if (operation === 'decrement') {
          newValue = lastValue > 0 ? lastValue - 1 : 0;
        }

        if (operation === 'remove') {
          newValue = 0;
        }

        inputEl.value = newValue;
        this.itemQuantityChange(key, newValue);
      },
      increment() {
        this._adjustQty(this.$el, 'increment');
      },
      decrement() {
        this._adjustQty(this.$el, 'decrement');
      },
      remove() {
        this._adjustQty(this.$el, 'remove');
      },
    };
  });
});
